// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HXisB","name":"styles_name__1eCtj","phone":"styles_phone__tx6n4"};